import { render, staticRenderFns } from "./Calculations.vue?vue&type=template&id=853de14e"
import script from "./Calculations.vue?vue&type=script&lang=ts"
export * from "./Calculations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports